import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import CardExpand from '@/views/components/CardExpand.vue';
import { mdiEye } from '@mdi/js';
import { IPareceres } from '../../types';
import { ConsultaParecerStore } from '@/views/parecer/store/ConsultaParecerStore';
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';

interface IProps {
  parecer?: IPareceres;
  isSelecionado: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardResultado',
  props: {
    parecer: null,
    isSelecionado: { type: Boolean }
  },
  emits: ['toggle-check'],
  setup(__props: any) {

const props = __props as {
  parecer?: IPareceres;
  isSelecionado: boolean;
};

const store = ConsultaParecerStore();




const showDetalhes = ref(false);

const highlightedDesc = computed(() => props.parecer?.highlightedDesc || '');

return { __sfc: true,store, props, showDetalhes, highlightedDesc, CardExpand, mdiEye, mdiChevronDown, mdiChevronUp }
}

})